import { Box } from '@mui/material';
import GoogleAdSense, { AD_SLOT } from './GoogleAdSense';
import { AD_TYPE, PAGE_TYPE } from '../../constants/gaEnums';

const SLOT_BY_PAGE = {
  [PAGE_TYPE.MYPAGE]: AD_SLOT.MYPAGE_RIGHT_STICKY,
  [PAGE_TYPE.NOTICE_POST]: AD_SLOT.NOTICE_POST_RIGHT_STICKY,
  [PAGE_TYPE.NOTICE_MAIN]: AD_SLOT.NOTICE_RIGHT_STICKY_2,
  [PAGE_TYPE.LIST_POST]: AD_SLOT.LISTS_POST_RIGHT_STICKY,
  [PAGE_TYPE.LISTS_MAIN]: AD_SLOT.LISTS_RIGHT_STICKY,
  [PAGE_TYPE.NEWS_POST]: AD_SLOT.NEWS_POST_RIGHT_STICKY,
  [PAGE_TYPE.NEWS_MAIN]: AD_SLOT.NEWS_RIGHT_STICKY,
  [PAGE_TYPE.REVIEWS_POST]: AD_SLOT.REVIEWS_RELATED_RIGHT_STICKY,
  [PAGE_TYPE.REVIEWS_USERREVIEWS]: AD_SLOT.REVIEWS_USERREVIEWS_RIGHT_STICKY,
  [PAGE_TYPE.REVIEWS_DETAIL]: AD_SLOT.REVIEWS_DETAIL_RIGHT_STICKY,
  [PAGE_TYPE.ARTIST]: AD_SLOT.ARTIST_RIGHT_STICKY,
  [PAGE_TYPE.ARTIST_VIEW_ALL]: AD_SLOT.ARTIST_MORE_RIGHT_STICKY,
  [PAGE_TYPE.SEARCH]: AD_SLOT.SEARCH_RIGHT_STICKY,
  [PAGE_TYPE.SEARCH_MORE]: AD_SLOT.SEARCH_MORE_RIGHT_STICKY,
  [PAGE_TYPE.HOME]: AD_SLOT.HOME_RIGHT_STICKY,
};

const SidebarAd = ({ pageType }) => (
  <Box
    sx={{
      display: { xs: 'none', lg: 'block' },
      width: 220,
      flexShrink: 0,
      px: '30px',
    }}
  >
    <Box sx={{ position: 'sticky', top: 80, display: 'flex', justifyContent: 'center' }}>
      <GoogleAdSense
        adSlot={SLOT_BY_PAGE[pageType]}
        adType={AD_TYPE.SIDEBAR_160_600}
        pageType={pageType}
        sx={{ width: 160, height: 600 }}
      />
    </Box>
  </Box>
);

export default SidebarAd;
